<template>
  <div class="certificates-body mb-6">
    <div>
      <div class="mx-auto max-w-4xl w-full mb-8">
        <div class="text-2xl leading-loose mt-1">
          <GoBackButton />
          <h3>{{ $t("message.certificates.title") }}</h3>
        </div>
      </div>
    </div>
    <div class="mx-auto">
      <template v-if="!create">
        <div class="mx-auto max-w-4xl w-full mb-12">
          <zt-button
            @click="handleCreateButton"
            class="create-button"
            data-vs-button="create-certificate"
            icon="plus-circle"
            :disabled="showWarningAlert"
          >
            {{ $t("message.certificates.createCert") }}
          </zt-button>
        </div>

      <div v-if="showWarningAlert"
        class="mx-auto max-w-4xl w-full mb-16 bg-cert-info border rounded border-0 flex py-6 px-4 "
      >
        <div class="flex justify-start items-start ml-1 mr-4">
          <zt-icon name="info" class="info-icon" />
        </div>
        <div class="flex flex-col">
          <p class="info-text text-zt-base font-normal">
            {{ $t("message.certificates.createAlertTitle") }}
          </p>

          <p class="info-text text-zt-base font-normal pt-4">
            {{ $t("message.certificates.createCertAlertSteps") }}
            <ul class="list-disc pl-8">
              <li>{{ $t("message.certificates.createCertAlertSteps_1") }}</li>
              <li>{{ $t("message.certificates.createCertAlertSteps_2") }}</li>
            </ul>
          </p>
        </div>

      </div>

        <template v-if="!certificates.length">
          <empty-state />
        </template>
        <template v-else>
          <certificates-list :certificatesList="certificates" @get-certificates="getCerts" />
        </template>
      </template>
      <template v-else>
        <new-certificate @cancelCreateCertificate="create = false" @created="certCreated" />
      </template>
    </div>
  </div>
</template>

<script>
import Certificates from "@/apiClient/Certificates";
import NewCertificate from "./components/NewCertificate";
import EmptyState from "./components/EmptyState";
import CertificatesList from "./components/CertificatesList";
import GoBackButton from "@/components/generics/GoBackButton.vue";

export default {
  components: {
    NewCertificate,
    EmptyState,
    CertificatesList,
    GoBackButton,
  },
  data() {
    return {
      create: false,
      cert: "",
      certificates: [],
      showWarningAlert: false,
    };
  },

  methods: {
    handleCreateButton() {
      this.create = true;
    },
    certCreated() {
      this.create = false;
      this.getCerts();
    },
    getCerts() {
      this.cert.getCertificatesList()
        .then((response) => {
          this.certificates = response.data.results.data;
          this.getNumberCertificatesActives();
        });
    },
    getNumberCertificatesActives(){
      let countCertificatesActives = 0;
      this.certificates.map(certificate => certificate.enabled && countCertificatesActives++);
      const currentCertificatesActives = this.$store.state.user.certificate_limit;
      this.showWarningAlert = countCertificatesActives === currentCertificatesActives;
    }
  },
  async mounted() {
    this.cert = new Certificates();
    await this.getCerts();
  },
};
</script>

<style scoped lang="scss">

.certificates-body {
  height: calc(100vh - 125px);
}
.create-button {
  height: 4rem !important;
  font-weight: 500;
}
.zt-modal-footer {
  background-color: #eeeeee;

  .zt-button {
    box-shadow: none;
    font-size: 1rem;
    font-weight: 500;
  }
  .button-cancel-only-text {
    background-color: #eeeeee !important;
    color: #949494 !important;
  }
}
  .info-text {
    color: #017eec !important;
    opacity: 1 !important;
  }
  .h-info {
    height: 7rem;
  }
  .info-icon {
    color: #def3ff !important;
    background: #017eec !important;
    border-radius: 50%;
    font-size: 1.2rem;
    padding-block: 0.23rem !important;
  }
  .bg-cert-info {
    background: #def3ff 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
  }
  .w-info-icon {
    width: 12%;
  }
  .w-info-text {
    width: 80%;
  }
</style>
